/*!
 * KoliBri - The accessible HTML-Standard
 */
import { c as createPropDefinition, n as normalizeString } from './normalizers-BNeak4hj.js';
import { h as hasEnoughReadableChars, c as containsOnlyNumbers } from './label-w3T7Y2ih.js';
import { k as a11yHint, z as uiUxHint } from './common-D-vggmh2.js';

function labelHints(_propName, value) {
    if (typeof value === 'string' && value !== '') {
        if (hasEnoughReadableChars(value, 3) === false && containsOnlyNumbers(value) === false) {
            a11yHint(`The heading or label ("${value}") is inaccessible. A label should consist of at least three readable characters.`);
        }
        if (value.length > 80) {
            uiUxHint(`A heading or label should not be longer than 80 characters.`);
        }
    }
}

const labelProp = createPropDefinition('label', '', normalizeString, (v) => v === '' || (v.length >= 2 && v.length <= 80), {
    hints: labelHints,
});

export { labelProp as l };
//# sourceMappingURL=label-FtX-skKy.js.map

//# sourceMappingURL=label-FtX-skKy.js.map